import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';
var AssessmentQuestionService = /** @class */ (function (_super) {
    tslib_1.__extends(AssessmentQuestionService, _super);
    function AssessmentQuestionService(http) {
        var _this = _super.call(this, 'assessment-question', http) || this;
        _this.http = http;
        return _this;
    }
    AssessmentQuestionService.prototype.ngOnInit = function () {
    };
    return AssessmentQuestionService;
}(BaseService));
export { AssessmentQuestionService };
